/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Celerity.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  AssignTransactionsToClaimResponse,
  AssignTransactionsToExistingClaimRequest,
  ClaimAttachmentDto,
  ClaimBulkActionRequest,
  ClaimDto,
  ClaimStatusDto,
  ClaimSubmissionResponse,
  CreateClaimRequest,
  CreateClaimResponse,
  SearchRequest,
  SearchResultOfClaimDto,
  UnAssignTransactionsFromClaimRequest,
  UnAssignTransactionsFromClaimResponse,
  UpdateClaimCreditMemoRequest,
  UpdateClaimRequest,
  UploadAttachmentBody
} from '../model';

import { apiRequest } from '../../client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * Create a claim. Authorization is derived from the authenticated caller — the entitlement the
 * removed web BFF enforced now lives here, so callers no longer supply a permission payload. The
 * distributor the claim belongs to defaults to the caller's own organization; see
 * Guid? CreateClaimRequest.DistributorID for when it may be named explicitly.
 * @summary Creates Claim.
 */
export const createClaim = (
    createClaimRequest: CreateClaimRequest,
 options?: SecondParameter<typeof apiRequest<CreateClaimResponse>>,) => {
      return apiRequest<CreateClaimResponse>(
      {url: `/claims`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createClaimRequest
    },
      options);
    }
  /**
 * Exports the claim, transforms it to the manufacturer's format, and submits it over SFTP
 * (DEV-956). The manufacturer's registered C# transform runs in-process and delivers synchronously.
 * With no registered transform, the outcome is NoConnection when there is no electronic delivery,
 * and NoOutput with a transformation-failed notification otherwise.
 * Replaces the web app's separate export + Python `/transform/outbound` + `/transfer/output` calls.
 * @summary Transform and submit a claim to its manufacturer.
 */
export const submitClaim = (
    claimId: string,
    nullString?: null | string,
 options?: SecondParameter<typeof apiRequest<ClaimSubmissionResponse>>,) => {
      return apiRequest<ClaimSubmissionResponse>(
      {url: `/claims/${claimId}/submit`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: nullString
    },
      options);
    }
  /**
 * Search claims, scoped to the caller's organization.
 * @summary Search Claims.
 */
export const searchClaims = (
    searchRequest: SearchRequest,
 options?: SecondParameter<typeof apiRequest<SearchResultOfClaimDto>>,) => {
      return apiRequest<SearchResultOfClaimDto>(
      {url: `/claims/search`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: searchRequest
    },
      options);
    }
  /**
 * Get a claim. Authorization is derived from the authenticated caller — the entitlement check
 * the removed web BFF enforced now lives here, so callers no longer supply their own permission
 * payload.
 * @summary Get Claim.
 */
export const getClaim = (
    claimId: string,
 options?: SecondParameter<typeof apiRequest<ClaimDto>>,) => {
      return apiRequest<ClaimDto>(
      {url: `/claims/${claimId}`, method: 'GET'
    },
      options);
    }
  /**
 * Update a claim. Authorization is derived from the authenticated caller — the entitlement the
 * removed web BFF enforced now lives in this controller, which also resolves which side of the
 * partnership owns the requested transition, so callers no longer supply a permission payload.
 * @summary Updates Claim.
 */
export const updateClaim = (
    claimId: string,
    updateClaimRequest: UpdateClaimRequest,
 options?: SecondParameter<typeof apiRequest<ClaimDto>>,) => {
      return apiRequest<ClaimDto>(
      {url: `/claims/${claimId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateClaimRequest
    },
      options);
    }
  /**
 * Get the status history for a claim. Authorization is derived from the authenticated caller —
 * the entitlement check the removed web BFF enforced now lives here, so callers no longer supply
 * their own permission payload.
 * @summary Get Claim Status History.
 */
export const getClaimStatuses = (
    claimId: string,
 options?: SecondParameter<typeof apiRequest<ClaimStatusDto[]>>,) => {
      return apiRequest<ClaimStatusDto[]>(
      {url: `/claims/${claimId}/statuses`, method: 'GET'
    },
      options);
    }
  /**
 * Upload a file attachment to a claim for the authenticated user.
 * @summary Upload Claim Attachment.
 */
export const uploadAttachment = (
    claimID: string,
    uploadAttachmentBody: UploadAttachmentBody,
 options?: SecondParameter<typeof apiRequest<ClaimAttachmentDto>>,) => {const formData = new FormData();
formData.append(`file`, uploadAttachmentBody.file);

      return apiRequest<ClaimAttachmentDto>(
      {url: `/claims/${claimID}/attachments`, method: 'POST',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData
    },
      options);
    }
  /**
 * Get all file attachments for a claim.
 * @summary Get Claim Attachments.
 */
export const getAttachments = (
    claimID: string,
 options?: SecondParameter<typeof apiRequest<ClaimAttachmentDto[]>>,) => {
      return apiRequest<ClaimAttachmentDto[]>(
      {url: `/claims/${claimID}/attachments`, method: 'GET'
    },
      options);
    }
  /**
 * Download a claim attachment file.
 * @summary Download Claim Attachment.
 */
export const downloadAttachment = (
    claimID: string,
    attachmentID: string,
 options?: SecondParameter<typeof apiRequest<Blob>>,) => {
      return apiRequest<Blob>(
      {url: `/claims/${claimID}/attachments/${attachmentID}/download`, method: 'GET',
        responseType: 'blob'
    },
      options);
    }
  /**
 * Gets pre-signed URLs for downloading a claim's submission file(s) from S3.
 * @summary Get Submission Pre-Signed URLs.
 */
export const getPresignedUrlsForClaimSubmissionFiles = (
    claimID: string,
 options?: SecondParameter<typeof apiRequest<string[]>>,) => {
      return apiRequest<string[]>(
      {url: `/claims/${claimID}/download/submission`, method: 'GET'
    },
      options);
    }
  /**
 * Gets pre-signed URLs for downloading a claim's response file(s) from S3.
 * @summary Get Response Pre-Signed URLs.
 */
export const getPresignedUrlsForClaimResponseFiles = (
    claimID: string,
 options?: SecondParameter<typeof apiRequest<string[]>>,) => {
      return apiRequest<string[]>(
      {url: `/claims/${claimID}/download/response`, method: 'GET'
    },
      options);
    }
  /**
 * Update the credit memo on a claim.
 * @summary Updates Claim Credit Memo.
 */
export const updateClaimCreditMemo = (
    claimId: string,
    updateClaimCreditMemoRequest: UpdateClaimCreditMemoRequest,
 options?: SecondParameter<typeof apiRequest<ClaimDto>>,) => {
      return apiRequest<ClaimDto>(
      {url: `/claims/${claimId}/creditmemo`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateClaimCreditMemoRequest
    },
      options);
    }
  /**
 * Archive the given claims and every transaction on them, from any claim status. Neither claim
 * nor transaction status changes — archival is a flag, orthogonal to the status history. Only
 * the claims' distributor may archive; every requested claim must exist and belong to the
 * caller, or the whole request is rejected.
 * @summary Archive Claims.
 */
export const archiveClaims = (
    claimBulkActionRequest: ClaimBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<string[]>>,) => {
      return apiRequest<string[]>(
      {url: `/claims/archive`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: claimBulkActionRequest
    },
      options);
    }
  /**
 * Restore the given archived claims and every transaction on them, including transactions that
 * were archived before the claim was. Nothing is re-queued for validation — restored claimed
 * transactions keep their claim-derived state. Authorization matches archive.
 * @summary Restore Claims.
 */
export const restoreArchivedClaims = (
    claimBulkActionRequest: ClaimBulkActionRequest,
 options?: SecondParameter<typeof apiRequest<string[]>>,) => {
      return apiRequest<string[]>(
      {url: `/claims/restore`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: claimBulkActionRequest
    },
      options);
    }
  /**
 * Assign transactions to an existing claim.
 * @summary Assign Transactions to Claim.
 */
export const assignTransactionsToExistingClaim = (
    claimId: string,
    assignTransactionsToExistingClaimRequest: AssignTransactionsToExistingClaimRequest,
 options?: SecondParameter<typeof apiRequest<AssignTransactionsToClaimResponse>>,) => {
      return apiRequest<AssignTransactionsToClaimResponse>(
      {url: `/claims/${claimId}/transactions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: assignTransactionsToExistingClaimRequest
    },
      options);
    }
  /**
 * Un-assigns a list of transactions from a claim by transactions and claim ID.
 * @summary Unassign Transactions from Claim.
 */
export const unAssignTransactions = (
    claimId: string,
    unAssignTransactionsFromClaimRequest: UnAssignTransactionsFromClaimRequest,
 options?: SecondParameter<typeof apiRequest<UnAssignTransactionsFromClaimResponse>>,) => {
      return apiRequest<UnAssignTransactionsFromClaimResponse>(
      {url: `/claims/${claimId}/transactions`, method: 'DELETE',
      headers: {'Content-Type': 'application/json', },
      data: unAssignTransactionsFromClaimRequest
    },
      options);
    }
  /**
 * Delete a claim. Authorization is derived from the authenticated caller — the entitlement the
 * removed web BFF enforced now lives here, so callers no longer supply a permission payload.
 * @summary Delete Claim.
 */
export const deleteClaim = (
    claimID: string,
 options?: SecondParameter<typeof apiRequest<void>>,) => {
      return apiRequest<void>(
      {url: `/claims/${claimID}`, method: 'DELETE'
    },
      options);
    }
  export type CreateClaimResult = NonNullable<Awaited<ReturnType<typeof createClaim>>>
export type SubmitClaimResult = NonNullable<Awaited<ReturnType<typeof submitClaim>>>
export type SearchClaimsResult = NonNullable<Awaited<ReturnType<typeof searchClaims>>>
export type GetClaimResult = NonNullable<Awaited<ReturnType<typeof getClaim>>>
export type UpdateClaimResult = NonNullable<Awaited<ReturnType<typeof updateClaim>>>
export type GetClaimStatusesResult = NonNullable<Awaited<ReturnType<typeof getClaimStatuses>>>
export type UploadAttachmentResult = NonNullable<Awaited<ReturnType<typeof uploadAttachment>>>
export type GetAttachmentsResult = NonNullable<Awaited<ReturnType<typeof getAttachments>>>
export type DownloadAttachmentResult = NonNullable<Awaited<ReturnType<typeof downloadAttachment>>>
export type GetPresignedUrlsForClaimSubmissionFilesResult = NonNullable<Awaited<ReturnType<typeof getPresignedUrlsForClaimSubmissionFiles>>>
export type GetPresignedUrlsForClaimResponseFilesResult = NonNullable<Awaited<ReturnType<typeof getPresignedUrlsForClaimResponseFiles>>>
export type UpdateClaimCreditMemoResult = NonNullable<Awaited<ReturnType<typeof updateClaimCreditMemo>>>
export type ArchiveClaimsResult = NonNullable<Awaited<ReturnType<typeof archiveClaims>>>
export type RestoreArchivedClaimsResult = NonNullable<Awaited<ReturnType<typeof restoreArchivedClaims>>>
export type AssignTransactionsToExistingClaimResult = NonNullable<Awaited<ReturnType<typeof assignTransactionsToExistingClaim>>>
export type UnAssignTransactionsResult = NonNullable<Awaited<ReturnType<typeof unAssignTransactions>>>
export type DeleteClaimResult = NonNullable<Awaited<ReturnType<typeof deleteClaim>>>
